import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import styles from './FeatureMeasure.module.css';
import img from '../assets/3.jpg';

const FeatureMeasure = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end end"]
  });
  
  // Dramatic zoom in as you scroll
  const scaleImage = useTransform(scrollYProgress, [0, 0.5, 1], [1, 1.3, 1.8]);
  
  // Overlay Darkening 
  const currentOverlayOpacity = useTransform(scrollYProgress, [0.3, 0.8], [0.5, 0.85]);

  // Text comes up from the bottom and fades in
  const textY = useTransform(scrollYProgress, [0.1, 0.4], [100, 0]);
  const textOpacity = useTransform(scrollYProgress, [0.1, 0.4, 0.8, 1], [0, 1, 1, 0.3]);

  return (
    <div ref={ref} className={styles.scrollContainer}>
      <div className={styles.stickyViewport}>
        <motion.div 
          className={styles.bg}
          style={{ 
            backgroundImage: `url(${img})`,
            scale: scaleImage,
            transformOrigin: "center center"
          }}
        />
        <motion.div 
          className={styles.overlay} 
          style={{ backgroundColor: "rgba(7, 8, 14, 1)", opacity: currentOverlayOpacity }}
        />

        <div className={styles.content}>
          <motion.div 
            className={styles.textContent}
            style={{ y: textY, opacity: textOpacity }}
          >
            <div className={styles.eyebrow}>
              MEASURE
            </div>
            <h2 className={styles.title}>
              Know exactly how loud.
            </h2>
            <p className={styles.body}>
              Noise Pad's real-time decibel meter captures your environment instantly. See average, max, and minimum levels at a glance — and get an immediate health-based reading: Healthy, Moderate, or Harmful.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default FeatureMeasure;
